import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { getRegionsAct } from "../../store/actions/regionActions";
import RegionsContent from "./RegionsContent/RegionsContent";
import PageHeader from "../shareableComponents/PageHeader";

import styles from "./styles";

const useStyles = makeStyles(styles);

const Regions = () => {
  const { t } = useTranslation("regionPage");
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRegionsAct());
  }, [dispatch]);

  return (
    <div className={classes.page}>
      <PageHeader title={t("title")} />
      <RegionsContent />
    </div>
  );
};

export default Regions;
